'use client';
/* eslint-disable no-restricted-imports */
import { useEffect } from 'react';
import NewGameContextProvider from '~/client/components/Game/context/Game/GameContextProvider/NewGameContextProvider';
import createChangeCurrencyNotification from '~/client/components/Game/createChangeCurrencyNotification';
import useRewardsNotificationStore from '~/client/components/Game/hooks/useNotificationStore';
import MobileGameModules from './MobileGameModules';
import { CashierCurrencyType } from '@/graphql/schema';

type Props = {
  game: SingleGameFragment;
  gameDescription?: GameDescriptionFragment;
  gameSession?: GameSessionFragment;
  rewardsNotification: RewardsNotification;
  inGameCurrencyList: string[];
  inGameCurrency?: Unit;
  cashierCurrencyType?: CashierCurrencyType;
  cashierCurrency?: CashierCurrency;
  isLoggedIn: boolean;
  translations: Record<string, string>;
  isUbtcEnabled: boolean;
  isBitcasino?: boolean;
};

const MobileGameView: FC<Props> = ({
  game,
  gameDescription,
  gameSession,
  inGameCurrencyList,
  inGameCurrency,
  cashierCurrency,
  cashierCurrencyType,
  isLoggedIn,
  translations,
  isUbtcEnabled,
  rewardsNotification,
  isBitcasino,
}) => {
  const { setNotifications } = useRewardsNotificationStore();

  useEffect(() => {
    if (rewardsNotification.isShowNotification) {
      createChangeCurrencyNotification(
        rewardsNotification.body,
        rewardsNotification.title,
        rewardsNotification.isRequiredToSwitch,
        rewardsNotification.rewardCurrencyIcon,
        rewardsNotification.rewardId,
      );
      setNotifications('freeBetReward');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rewardsNotification]);

  return (
    <NewGameContextProvider
      game={game}
      gameSession={gameSession}
      gameDescription={gameDescription}
    >
      <MobileGameModules
        inGameCurrencyList={inGameCurrencyList}
        inGameCurrency={inGameCurrency}
        cashierCurrencyType={cashierCurrencyType}
        cashierCurrency={cashierCurrency}
        isLoggedIn={isLoggedIn}
        translations={translations}
        isUbtcEnabled={isUbtcEnabled}
        rewardsNotification={rewardsNotification}
        isBitcasino={isBitcasino}
      />
    </NewGameContextProvider>
  );
};

export default MobileGameView;
